import { createContext } from 'react';

interface ListContextType {
  handleChange: (value: string) => void;
  currentValue: string;
}

export const ListContext = createContext<ListContextType>({
  handleChange: () => {},
  currentValue: '',
});